"use client"

import { useEffect } from "react"
import AnnualQuarterAllSwitch from "./AnuualQuarterAllSwitch"
import TanshinTable from "./TanshinTable"
import { saveAccessLog } from "../utils/commonUtils"
import TwoColumnSwitch from "../utils/TwoColumnSwitch"
import { ArrowRight } from "lucide-react"

const TanshinSearch = ({
  tanshinData,
  onDashboardClick,
  selectedCompanies,
  onCompanyClick,
  addAllCompanies,
  addCompany,
  removeCompany,
  registeredCompanies,
  handleOpenAnalysis,
  handleTanshinCountrySelect,
  tanshinCountry,
  selectedPeriod,
  setSelectedPeriod,
  isMobile,
}) => {
  const handlePeriodChange = (period) => {
    setSelectedPeriod(period)
  }

  useEffect(() => {
    saveAccessLog("analysis tanshin search")
  }, [])

  const options = [
    { id: "JP", label: "日本" },
    { id: "US", label: "米国" },
  ]

  // 統合された検索結果ヘッダー
  const renderResultHeader = () => (
    <div className={isMobile ? "px-4 py-2" : "ml-4"}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex flex-wrap gap-2">
          <AnnualQuarterAllSwitch onPeriodChange={handlePeriodChange} />
          <TwoColumnSwitch
            options={options}
            onChange={handleTanshinCountrySelect}
            defaultId={tanshinCountry}
            isMobile={isMobile}
          />
        </div>

        {selectedCompanies && selectedCompanies.length > 0 && (
          <div className="ml-auto">
            {isMobile ? (
              <button
                onClick={handleOpenAnalysis}
                className="flex items-center justify-center w-[120px] gap-1.5 bg-gray-800 text-white px-3 py-1.5 rounded-md text-sm font-medium hover:bg-gray-700 transition-colors"
              >
                分析を表示
                <ArrowRight className="w-3.5 h-3.5" />
              </button>
            ) : (
              <div
                className="show-analysis-sm p-1 bg-green-500 w-[120px] flex align-center items-center text-white rounded-2xl cursor-pointer"
                onClick={handleOpenAnalysis}
              >
                分析画面を開く
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )

  return (
    <div className={isMobile ? "" : "tabcontent-search"}>
      <div className={isMobile ? "" : "analysis-container"}>
        <div className={isMobile ? "py-2" : "py-[5px] md:p-[10px]"}>
          {/* 統合された検索結果ヘッダー */}
          {renderResultHeader()}
        </div>
        {tanshinData && (
          <TanshinTable
            tanshinData={tanshinData}
            period={selectedPeriod}
            onDashboardClick={onDashboardClick}
            selectedCompanies={selectedCompanies}
            onCompanyClick={onCompanyClick}
            addAllCompanies={addAllCompanies}
            addCompany={addCompany}
            removeCompany={removeCompany}
            registeredCompanies={registeredCompanies}
            isMobile={isMobile}
          />
        )}
      </div>
    </div>
  )
}

export default TanshinSearch
